import Vue from 'vue'
import BasicBreadcrumb from '../common/BasicBreadcrumb'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(BasicBreadcrumb)
}).$mount('#breadcrumb')
